/* Dialog Text */
import { Component, Inject } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../../DialogResult";
import {
  AdminCouponsLevelsService,
  AdminInteractiveService,
  AdminInteractiveSubService,
  AdminCouponsService,
  AdminXmlaSubscriptionService,
  ReportExportService,
} from "../../../api/services";
import {
  InteractSubType,
  InteractSubLevel,
  CouponsLevels,
  XmlaSubscriptionLevelEx,
  XmlaSubscriptionTypeEx,
  ReportSubscriptionType,
  ReportSubscriptionLevelEx,
} from "../../../api/models";
import {
  ConfirmDialogData,
  ConfirmDialogComponent,
} from "../../confirm-dialog/confirm-dialog.component";
import {
  EditCouponLevelDialogData,
  EditCouponLevelDialogComponent,
} from "../edit-coupon-level-dialog/edit-coupon-level-dialog.component";
import { MessageDialogComponent } from "../../message-dialog/message-dialog.component";

export interface EditCouponLevelsDialogData {
  dialogTitle: string;
  isNew: boolean;
  couponCode: string;
  adminCouponLevelsService: AdminCouponsLevelsService;
  adminInteractiveSubService: AdminInteractiveSubService;
  reportExportService: ReportExportService;
}

@Component({
  selector: "edit-coupon-levels-dialog",
  styleUrls: ["edit-coupon-levels-dialog.component.css"],
  templateUrl: "./edit-coupon-levels-dialog.component.html",
})
export class EditCouponLevelsDialogComponent {
  public Result: DialogResult;
  public LoadingData: boolean = true;
  public subTypes: InteractSubType[];
  public subLevels: InteractSubLevel[];
  public availableSubLevels: InteractSubLevel[];
  public reportSubTypes: ReportSubscriptionType[];
  public reportSubLevels: ReportSubscriptionLevelEx[];
  public couponLevels: CouponLevelDisplay[];

  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<EditCouponLevelsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditCouponLevelsDialogData
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;

    this.data.adminInteractiveSubService
      .adminInteractiveSubGetInteractSubTypes()
      .subscribe((subTypeResults) => {
        this.subTypes = subTypeResults;
        this.data.adminInteractiveSubService
          .adminInteractiveSubGetInteractSubLevels()
          .subscribe((subLevelsResult) => {
            this.subLevels = subLevelsResult;
            this.data.reportExportService.reportExportGetReportSubscriptionTypes()
              .subscribe((reportTypes) => {
                this.reportSubTypes = reportTypes;
                this.data.reportExportService.reportExportGetReportSubscriptionLevels()
                  .subscribe((reportLevels) => {
                    this.reportSubLevels = reportLevels;
                    this.loadCouponLevels();
                  });
              });
          });
      });
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    this.Result.ResultType = DialogResultType.Ok;
    this.Result.ResultData = this.data;
    this.dialogRef.close(this.Result);
  }

  loadCouponLevels() {
    var params: AdminCouponsLevelsService.AdminCouponsLevelsGetCouponsLevels2Params = {
      id: this.data.couponCode,
      couponCode: this.data.couponCode,
    };

    this.data.adminCouponLevelsService
      .adminCouponsLevelsGetCouponsLevels2(params)
      .subscribe((result) => {
        this.couponLevels = [];

        for (var i = 0; i < result.length; i++) {
          var couponLevel: CouponLevelDisplay = {
            CouponCode: result[i].couponCode,
            InteractSubscriptionLevelId: result[i].interactSubLevelId,
            InteractSubscriptionTypeId: result[i].interactSubTypeId,
            ReportSubscriptionTypeId: result[i].reportSubscriptionTypeId,
            ReportSubscriptionLevelId: result[i].reportSubscriptionLevelId,
            SubscriptionLevel: "",
            SubscriptionType: "",
            PurchaseUrl: result[i].purchaseUrl,
          };

          if (result[i].interactSubTypeId !== null) {
            for (var e = 0; e < this.subTypes.length; e++) {
              if (
                this.subTypes[e].interactSubTypeId ==
                couponLevel.InteractSubscriptionTypeId
              ) {
                couponLevel.SubscriptionType = this.subTypes[e].description;
              }
            }

            for (var e = 0; e < this.subLevels.length; e++) {
              if (
                this.subLevels[e].interactSubTypeId ==
                  couponLevel.InteractSubscriptionTypeId &&
                this.subLevels[e].interactSubLevelId ==
                  couponLevel.InteractSubscriptionLevelId
              ) {
                couponLevel.SubscriptionLevel = this.subLevels[e].description;
              }
            }
          } else if (result[i].reportSubscriptionTypeId != null) {
            for (var e = 0; e < this.reportSubTypes.length; e++) {
              if (
                this.reportSubTypes[e].reportSubscriptionTypeId ==
                couponLevel.ReportSubscriptionTypeId
              ) {
                couponLevel.SubscriptionType = this.reportSubTypes[
                  e
                ].name;
              }
            }

            for (var e = 0; e < this.reportSubLevels.length; e++) {
              if (
                this.reportSubLevels[e].reportSubscriptionTypeId ==
                  couponLevel.ReportSubscriptionTypeId &&
                this.reportSubLevels[e].reportSubscriptionLevelId ==
                  couponLevel.ReportSubscriptionLevelId
              ) {
                couponLevel.SubscriptionLevel = this.reportSubLevels[
                  e
                ].description;
              }
            }
          }

          this.couponLevels.push(couponLevel);
        }
      });
  }

  deleteCouponLevel(couponLevel: CouponLevelDisplay): boolean {
    ConfirmDialogComponent.showDialog(
      this.dialog,
      "Confirm Delete",
      "Are you sure you want to delete this coupon level?"
    ).subscribe((result) => {
      if (
        result != null &&
        result.ResultType != null &&
        result.ResultType == DialogResultType.Ok
      ) {
        var deleteParam: AdminCouponsLevelsService.AdminCouponsLevelsDeleteCouponsLevelsParams = {
          couponCode: couponLevel.CouponCode,
          interactSubType: couponLevel.InteractSubscriptionTypeId == null ? 0 : couponLevel.InteractSubscriptionTypeId,
          interactSubLevel: couponLevel.InteractSubscriptionLevelId == null ? 0 : couponLevel.InteractSubscriptionLevelId,
          reportSubType: couponLevel.ReportSubscriptionTypeId == null ? 0 : couponLevel.ReportSubscriptionTypeId,
          reportSubLevel: couponLevel.ReportSubscriptionLevelId == null ? 0 : couponLevel.ReportSubscriptionLevelId,
        };

        this.data.adminCouponLevelsService
          .adminCouponsLevelsDeleteCouponsLevels(deleteParam)
          .subscribe(
            (result) => {
              MessageDialogComponent.showDialog(
                this.dialog,
                "Success",
                "Level Deleted"
              ).subscribe((result) => {
                this.loadCouponLevels();
              });
            },
            (error) => {
              MessageDialogComponent.showDialog(
                this.dialog,
                "Error",
                "Failed To Delete Level"
              ).subscribe((result) => {});
            }
          );
      }
    });

    return false;
  }

  addCouponLevel() {
    var params: EditCouponLevelDialogData = {
      dialogTitle: "Create Coupon Level",
      isNew: true,
      couponCode: this.data.couponCode,
      reportSubscriptionTypeId: null,
      reportSubscriptionLevelId: null,
      interactSubscriptionTypeId: null,
      interactSubscriptionLevelId: null,
      interactSubscriptionTypes: this.subTypes,
      interactSubscriptionLevels: this.subLevels,
      reportSubscriptionTypes: this.reportSubTypes,
      reportSubscriptionLevels: this.reportSubLevels,
    };

    var dialogRef = this.dialog.open(EditCouponLevelDialogComponent, {
      disableClose: true,
      width: "500px",
      data: params,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result != null &&
        result.ResultType != null &&
        result.ResultType == DialogResultType.Ok
      ) {
        params = result.ResultData;
        var couponLevel: CouponsLevels = {
          couponCode: params.couponCode,
          interactSubTypeId: params.interactSubscriptionTypeId,
          interactSubLevelId: params.interactSubscriptionLevelId,
          reportSubscriptionTypeId: params.reportSubscriptionTypeId,
          reportSubscriptionLevelId: params.reportSubscriptionLevelId,
          xmlaSubscriptionTypeId: null,
          xmlaSubscriptionLevelId: null,
          couponLevelId: -1,
        };

        this.data.adminCouponLevelsService
          .adminCouponsLevelsPostCouponsLevels(couponLevel)
          .subscribe(
            (result) => {
              MessageDialogComponent.showDialog(
                this.dialog,
                "Success",
                "Level Created"
              ).subscribe((result) => {
                this.loadCouponLevels();
              });
            },
            (error) => {
              MessageDialogComponent.showDialog(
                this.dialog,
                "Error",
                "Failed To Create Level"
              ).subscribe((result) => {});
            }
          );
      }
    });

    return false;
  }
}

export interface CouponLevelDisplay {
  CouponCode: string;
  InteractSubscriptionTypeId?: number;
  InteractSubscriptionLevelId?: number;
  ReportSubscriptionTypeId?: number;
  ReportSubscriptionLevelId?: number;
  SubscriptionType: string;
  SubscriptionLevel: string;
  PurchaseUrl: string;
}

/* Calling Methods */
/*
  callEditCouponLevels(params: EditCouponLevelsDialogData) {
    var dialogRef = this.dialog.open(EditCouponLevelsDialogComponent, {
      width: '500px',
      data: params
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result != null && result.ResultType != null && result.ResultType == DialogResultType.Ok) {
        //Do something here!
      }
    });
  }
*/
